import axiosInstance from './axiosInstance';
import { variables } from './variables';

const API_URL = variables.USER_API;

const userApi = {
  getCustomerListByEmail: async (emailId) => {
    const response = await axiosInstance.get(`${API_URL}/UserDetails/${emailId}?sortColumn=&sortOrder=asc&SearchTerm=&page=1&pageSize=50&searchBy=All`);
    return response.data;
  },

  getCustomerByEmail: async (email, customerId) => {
    const url = customerId 
      ? `${API_URL}/${email}?customerId=${customerId}` 
      : `${API_URL}/${email}`;
    const response = await axiosInstance.get(url);
    return response.data;
  }
};

export default userApi;
